// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CatalogSearch_field__l7eeI {
  display: grid;
  grid-template-columns: 1fr 4rem;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 10rem;
  background-color: var(--color-white);
  padding: 2rem 5rem;
}

.CatalogSearch_close__5LjaD {
  font-size: 3rem;
  display: flex;
  justify-content: flex-end;
}

.CatalogSearch_search__bg__\\+Uk5u {
  background-color: rgba(42, 40, 40, 0.7019607843);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: fixed;
  width: 100vw;
  z-index: 100;
  bottom: -12rem;
}
@media only screen and (max-width: 31.25em) {
  .CatalogSearch_search__bg__\\+Uk5u {
    bottom: -17rem;
  }
}
.CatalogSearch_search__found__0Uijj {
  width: 100%;
  min-height: 7rem;
  height: fit-content;
  max-height: 50vh;
  overflow-y: scroll;
  background-color: var(--color-white);
  padding: 2rem 5rem;
}
.CatalogSearch_search__public__Y9xHP {
  width: 100%;
  min-height: 7rem;
  height: fit-content;
  max-height: 50vh;
  overflow-y: scroll;
  background-color: var(--color-white);
  padding: 3rem;
}
.CatalogSearch_search__public__bg__-1QMS {
  background-color: rgba(42, 40, 40, 0.7019607843);
  display: flex;
  flex-direction: column;
  height: 100%;
  position: fixed;
  width: 100vw;
  z-index: 100;
  bottom: -11rem;
}
.CatalogSearch_search__empty__4CNtH {
  content: "";
  width: 100%;
  flex-grow: 1;
}
.CatalogSearch_search__items__sIMeJ {
  display: grid;
  grid-template-columns: 10rem 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
.CatalogSearch_search__items__sIMeJ:hover {
  background-color: var(--color-fash-green);
}

.CatalogSearch_pcSearch__mIaWX {
  margin-right: 5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Catalogue/CatalogSearch.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,+BAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;AADJ;;AAKA;EACI,eAAA;EACA,aAAA;EACA,yBAAA;AAFJ;;AAMI;EACI,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AAHR;AAKQ;EAVJ;IAWQ,cAAA;EAFV;AACF;AAKI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AAHR;AAMI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;AAJR;AAOQ;EACI,gDAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AALZ;AAUI;EACI,WAAA;EACA,WAAA;EACA,YAAA;AARR;AAYI;EACI,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAVR;AAYQ;EACI,yCAAA;AAVZ;;AAeA;EACI,kBAAA;AAZJ","sourcesContent":["@import '../variables/breakpoints';\n\n.field {\n    display: grid;\n    grid-template-columns: 1fr 4rem;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 10rem;\n    background-color: var(--color-white);\n    padding: 2rem 5rem;\n}\n\n\n.close {\n    font-size: 3rem;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.search {\n    &__bg {\n        background-color: #2a2828b3;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        position: fixed;\n        width: 100vw;\n        z-index: 100;\n        bottom: -12rem;\n\n        @media only screen and (max-width: $bp-500) {\n            bottom: -17rem;\n        }\n    }\n\n    &__found {\n        width: 100%;\n        min-height: 7rem;\n        height: fit-content;\n        max-height: 50vh;\n        overflow-y: scroll;\n        background-color: var(--color-white);\n        padding: 2rem 5rem;\n    }\n\n    &__public {\n        width: 100%;\n        min-height: 7rem;\n        height: fit-content;\n        max-height: 50vh;\n        overflow-y: scroll;\n        background-color: var(--color-white);\n        padding: 3rem;\n\n\n        &__bg {\n            background-color: #2a2828b3;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            position: fixed;\n            width: 100vw;\n            z-index: 100;\n            bottom: -11rem;\n        }\n\n    }\n\n    &__empty {\n        content: \"\";\n        width: 100%;\n        flex-grow: 1;\n    }\n\n\n    &__items {\n        display: grid;\n        grid-template-columns: 10rem 1fr;\n        gap: 1rem;\n        margin-bottom: 1rem;\n        cursor: pointer;\n\n        &:hover {\n            background-color: var(--color-fash-green);\n        }\n    }\n}\n\n.pcSearch {\n    margin-right: 5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `CatalogSearch_field__l7eeI`,
	"close": `CatalogSearch_close__5LjaD`,
	"search__bg": `CatalogSearch_search__bg__+Uk5u`,
	"search__found": `CatalogSearch_search__found__0Uijj`,
	"search__public": `CatalogSearch_search__public__Y9xHP`,
	"search__public__bg": `CatalogSearch_search__public__bg__-1QMS`,
	"search__empty": `CatalogSearch_search__empty__4CNtH`,
	"search__items": `CatalogSearch_search__items__sIMeJ`,
	"pcSearch": `CatalogSearch_pcSearch__mIaWX`
};
export default ___CSS_LOADER_EXPORT___;
